import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSolution } from './components/ProblemSolution';
import { WhatIsSection } from './components/WhatIsSection';
import { TomoCards } from './components/TomoCards';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { PricingSummary } from './components/PricingSummary';
import { TargetAudience } from './components/TargetAudience';
import { WhyThisSkill } from './components/WhyThisSkill';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel safely via script injection
    try {
      const pixelId = '832917643091578';
      // @ts-ignore
      if (!window.fbq) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        // @ts-ignore
        const fbq = window.fbq = function () {
          // @ts-ignore
          fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        // @ts-ignore
        fbq.push = fbq;
        // @ts-ignore
        fbq.loaded = true;
        // @ts-ignore
        fbq.version = '2.0';
        // @ts-ignore
        fbq.queue = [];
      }
      // @ts-ignore
      window.fbq('init', pixelId);
      // @ts-ignore
      window.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen bg-[#060e1a] font-sans selection:bg-yellow-300 selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSolution data-id="element-2" />
      <WhatIsSection data-id="element-3" />
      <TomoCards data-id="element-4" />
      <BonusSection data-id="element-5" />
      <Testimonials data-id="element-6" />
      <PricingSummary data-id="element-7" />
      <TargetAudience data-id="element-8" />
      <WhyThisSkill data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <SocialProofPopup data-id="element-12" />

      <noscript data-id="element-13">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=832917643091578&ev=PageView&noscript=1" alt="" data-id="element-14" />
      </noscript>
    </div>;
}